module.exports = __webpack_public_path__ + "static/img/wanted7.6c72501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted7.png
// module id = F96R
// module chunks = 1 3